import React from "react";
import { motion } from "framer-motion";

const STAT_INITIAL = { opacity: 0, y: 12 };
const STAT_ANIMATE = { opacity: 1, y: 0 };

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-1">
          StockLedger
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent, index = 0 }) {
  return (
    <motion.div
      initial={STAT_INITIAL}
      animate={STAT_ANIMATE}
      transition={{ delay: index * 0.05, duration: 0.3 }}
      className={`border border-border bg-card p-5 ${accent ? "bg-primary text-primary-foreground border-primary" : ""}`}
    >
      <div className="flex items-center justify-between">
        <div className={`text-xs uppercase tracking-[0.15em] font-semibold ${accent ? "text-primary-foreground/80" : "text-muted-foreground"}`}>
          {label}
        </div>
        {Icon && <Icon className={`w-4 h-4 ${accent ? "text-primary-foreground" : "text-muted-foreground"}`} />}
      </div>
      <div className="font-mono text-2xl sm:text-3xl font-bold mt-3 tracking-tight">{value}</div>
      {sub && <div className={`text-xs mt-1 ${accent ? "text-primary-foreground/70" : "text-muted-foreground"}`}>{sub}</div>}
    </motion.div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="border border-dashed border-border bg-card p-12 text-center">
      <h3 className="font-display text-xl font-bold">{title}</h3>
      {hint && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{hint}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    paid: "bg-success text-white",
    received: "bg-success text-white",
    sent: "bg-primary text-primary-foreground",
    ordered: "bg-primary text-primary-foreground",
    draft: "bg-secondary text-secondary-foreground",
  };
  return (
    <span className={`inline-block px-2 py-0.5 text-xs font-mono font-semibold uppercase ${map[status] || "bg-secondary"}`}>
      {status}
    </span>
  );
}
